<template>
  <div>
    <Form :model="awardData" :label-width="100">
      <FormItem label="奖品类型">
        <Select v-model="awardData.rewardType">
          <Option
            :value="item.value"
            v-for="item in rsList"
            :key="item.value"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="奖品id:">
        <Row>
          <Col span="11">
            <Input v-model="awardData.rewardId" placeholder="奖品Id"></Input>
          </Col>
          <Col span="2" style="text-align: center"> </Col>
          <Col span="11">
            <Button type="success" @click="getSourceIcon">获取图标</Button>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="奖品名称">
        <Row>
          <Col span="11">
            <Input
              v-model="awardData.rewardName"
              placeholder="获取图标后自动写入"
              :disabled="true"
            ></Input>
          </Col>
          <Col span="2" style="text-align: center"> </Col>
          <Col span="11">
            <div class="img-preview" v-if="!awardData.rewardIcon"></div>
            <img class="img-preview" :src="awardData.rewardIcon" v-else />
          </Col>
        </Row>
      </FormItem>
      <FormItem label="资源预览">
        <UploadSingleImg
          v-model="awardData.preUrl"
          :on-upload="newUploadImg"
        ></UploadSingleImg>
      </FormItem>
      <FormItem label="价值类型">
        <Select v-model="awardData.rewardLevel">
          <Option :value="1">低等价值</Option>
          <Option :value="2">高等价值</Option>
        </Select>
      </FormItem>

      <!-- <FormItem label="DatePicker">
        <Row>
          <Col span="11">
          <DatePicker type="date" placeholder="Select date" v-model="awardData.date"></DatePicker>
          </Col>
          <Col span="2" style="text-align: center">-</Col>
          <Col span="11">
          <TimePicker type="time" placeholder="Select time" v-model="awardData.time"></TimePicker>
          </Col>
        </Row>
      </FormItem> -->
      <FormItem label="广播类型">
        <RadioGroup v-model="awardData.notice">
          <Radio :label="0">无</Radio>
          <Radio :label="1">房间公屏</Radio>
          <Radio :label="2">全服</Radio>
          <Radio :label="3">房间公屏+全服</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="角标">
        <RadioGroup v-model="awardData.mark">
          <Radio :label="0">无</Radio>
          <Radio :label="1">稀有</Radio>
          <Radio :label="2">新品</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem v-if="docId <= 3" label="幸运奖池数量">
        <Input
          v-model="awardData.luckyCount"
          placeholder="请输入幸运奖池数量"
        ></Input>
      </FormItem>
      <FormItem v-if="docId > 3" label="高净值奖池数量">
        <Input
          v-model="awardData.luckyCount"
          placeholder="请输入高净值奖池数量"
        ></Input>
      </FormItem>
      <FormItem v-if="docId > 3" label="普通奖池数数量">
        <Input
          v-model="awardData.normalCount"
          placeholder="请输入普通奖池数量"
        ></Input>
      </FormItem>
      <FormItem v-if="docId === 901" label="低价值奖池数量">
        <Input
          v-model="awardData.trdCount"
          placeholder="请输入低价值奖池数量"
        ></Input>
      </FormItem>
      <FormItem label="排序">
        <Input v-model="awardData.orderId" placeholder="请输入排序"></Input>
      </FormItem>
      <FormItem label="资源有效期">
        <InputNumber v-model="awardData.expire" controls-outside></InputNumber>
      </FormItem>
      <FormItem label="奖品价值">
        <Input v-model="awardData.price" placeholder="请输入价值"></Input>
      </FormItem>
      <FormItem label="展示价值">
        <Input v-model="awardData.showPrice" placeholder="请输入价值"></Input>
      </FormItem>
      <FormItem label="概率">
        <Input v-model="awardData.rate" placeholder="请输入概率"></Input>
      </FormItem>
      <FormItem label="奖品状态">
        <i-switch
          v-model="awardData.valid"
          size="large"
          :true-value="1"
          :false-value="0"
        >
          <span slot="open">有效</span>
          <span slot="close">无效</span>
        </i-switch>
      </FormItem>
      <Button
        v-if="boxTypeList.includes(awardData.rewardType)"
        @click="addBoxDetail"
        size="small"
        color="primary"
        >新增</Button
      >
      <box-award-config
        v-if="boxTypeList.includes(awardData.rewardType)"
        :rsList="rsList"
        v-model="detailList[ind]"
        v-for="(item, ind) in awardData.rewardDetailList"
      />
    </Form>
  </div>
</template>

<script>
import UploadSingleImg from '@/components/UploadSingleImg/UploadSingleImg.vue'
import BoxAwardConfig from './BoxAwardConfig.vue'
import { getResourceInfoReq } from '@/api/carnivalApi'
import { resourceList, getResourceName } from './data'
// import { type } from 'vue-json-editor/assets/jsoneditor'
export default {
  components: {
    UploadSingleImg,
    BoxAwardConfig,
  },
  props: {
    rsList: {
      type: Array,
      default: () => {
        return []
      },
    },
    show: {
      type: Boolean,
    },
    docId: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      detailList: [],
      resourceList,
      boxTypeList: [9001, 9002, 9003],
    }
  },
  methods: {
    addBoxDetail() {
      this.detailList.push({
        rewardRelationId: 0,
        price: 0,
        mark: 0,
        orderId: 0,
        rewardType: 1,
        expire: 0,
        showPrice: 0,
        preUrl: '',
        rewardName: '',
        rewardIcon: '',
      })
    },
    getResourceName,
    selectResource(row) {
      this.awardData = { ...this.awardData, ...row }
    },

    async newUploadImg(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'starry/pre/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    // 获取图标资源和名称
    async getSourceIcon() {
      const res = await getResourceInfoReq({
        rewardId: this.awardData.rewardId,
        type: this.awardData.rewardType,
      })
      if (res.code === 0 || res.status === 0) {
        this.$Message.success('success')
        this.awardData = {
          ...this.awardData,
          rewardIcon: res.data.rewardIcon,
          rewardName: res.data.rewardName,
          price: res.data.price || this.awardData.price,
        }
      } else {
        this.$Message.error(res.msg || res.message)
      }
    },
  },
  computed: {
    awardData: {
      get() {
        let _this = this
        const proxy = new Proxy(this.value, {
          set(target, key, value) {
            _this.$emit('input', {
              ...target,
              [key]: value,
            })
            return true
          },
          get(target, key) {
            return Reflect.get(target, key)
          },
        })
        return proxy
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.detailList = newVal.rewardDetailList
      },
    },

    detailList(newVal) {
      this.awardData.rewardDetailList = this.detailList
    },
  },
  mounted() {},
}
</script>

<style scoped lang="scss">
.img-preview {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border: 2px dashed #eee;
}
</style>
